import { useEffect } from 'react'
import { ToonIntro, ToonOutro } from '@quebon/shared-learning'
import type { ToonCard, ToonQuizCard } from '@quebon/shared-learning'
import { X } from 'lucide-react'

type Props =
  | {
      open: boolean
      onClose: () => void
      mode: 'intro'
      cards: ToonCard[]
    }
  | {
      open: boolean
      onClose: () => void
      mode: 'outro'
      cards: ToonQuizCard[]
    }

export function ToonPreviewModal(props: Props) {
  const { open, onClose, mode } = props

  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={mode === 'intro' ? '깨봉툰 인트로' : '깨봉툰 아웃트로'}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl rounded-xl bg-white shadow-2xl overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
          <h2 className="text-sm font-medium text-slate-800">
            {mode === 'intro' ? '깨봉툰 인트로 체험' : '깨봉툰 아웃트로 체험'}
          </h2>
          <button
            onClick={onClose}
            aria-label="닫기"
            className="p-1 rounded hover:bg-slate-100"
          >
            <X className="w-5 h-5 text-slate-600" />
          </button>
        </div>

        <div className="max-h-[80vh] overflow-y-auto p-4 bg-lc-gray-c100">
          {props.mode === 'intro' ? (
            <ToonIntro
              cards={props.cards}
              onComplete={onClose}
              autoPlayAudio
            />
          ) : (
            <ToonOutro
              cards={props.cards}
              onComplete={onClose}
              autoPlayAudio
            />
          )}
        </div>
      </div>
    </div>
  )
}
